import React from 'react';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import './privacy-policy.css';

export default function PrivacyPolicy() {
    const { t } = useTranslation();
    const blocks = t('PrivacyPolicyBlocks', { returnObjects: true });

    return (
        <article className="privacy-policy">
            {blocks.map((block, index) => {
                switch (block.type) {
                    case 'heading':
                        return <Typography component="h3" key={index}>{block.text}</Typography>;
                    case 'subheading':
                        return <Typography component="h4" key={index}>{block.text}</Typography>;
                    case 'notice':
                        return <Typography key={index}><em>{block.text}</em></Typography>;
                    case 'ordered-list':
                        return <ol key={index} start={block.start}>{block.items.map((item, itemIndex) => <li key={itemIndex}>{item}</li>)}</ol>;
                    case 'unordered-list':
                        return <ul key={index}>{block.items.map((item, itemIndex) => <li key={itemIndex}>{item}</li>)}</ul>;
                    default:
                        return <Typography key={index}>{block.text}</Typography>;
                }
            })}
        </article>
    );
}
